export default __webpack_public_path__ + "static/media/mustard-yellow-4-designify.68bae5be.png";